import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';

interface AppShellProps {
  tenant: string;
}

export function AppShell({ tenant }: AppShellProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header tenant={tenant} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}
